export var ServiceChargeTypeEnum;
(function (ServiceChargeTypeEnum) {
    ServiceChargeTypeEnum["AUTO_APPLY"] = "AUTO_APPLY";
    ServiceChargeTypeEnum["DELIVERY_FEE"] = "DELIVERY_FEE";
    ServiceChargeTypeEnum["DELIVERY_TIP"] = "DELIVERY_TIP";
})(ServiceChargeTypeEnum || (ServiceChargeTypeEnum = {}));
//# sourceMappingURL=ServiceChargeTypeEnum.js.map